import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValueProposition } from 'ng2-app/models/dto/value-proposition.model';

@Component({
  selector: 'app-value-prop-item',
  templateUrl: './value-prop-item.component.html',
  styleUrls: ['./value-prop-item.component.scss'],
  standalone: false
})
export class ValuePropItemComponent {
  @Input() valueProp: ValueProposition;
  @Input() editMode : boolean = false;
  @Output() remove = new EventEmitter <ValueProposition>();

  removeItem() {
    this.remove.emit(this.valueProp);
  }
}
